import { useEffect, useState } from 'react';
import type { CharacterProfile } from '../types';
import { CharacterSpeakButton } from './CharacterSpeakButton';
import { ProgressIndicator } from './ProgressIndicator';

interface CharacterSlideshowProps { character: CharacterProfile; imageIndex: number; frameProgress: number; nextCharacter?: CharacterProfile; }

export function CharacterSlideshow({ character, imageIndex, frameProgress, nextCharacter }: CharacterSlideshowProps) {
  const [failed, setFailed] = useState(false);
  const current = character.images[imageIndex];

  useEffect(() => setFailed(false), [current.src]);

  useEffect(() => {
    const preload = new Image();
    preload.src = imageIndex < character.images.length - 1 ? character.images[imageIndex + 1].src : nextCharacter?.images[0].src ?? '';
  }, [character, imageIndex, nextCharacter]);

  return (
    <figure className="character-art">
      {!failed ? (
        <img
          key={current.src}
          src={current.src}
          srcSet={current.srcSet}
          sizes="(max-width: 980px) 100vw, 66vw"
          alt={current.alt}
          width={current.width}
          height={current.height}
          loading={character.id === 'absolution' ? 'eager' : 'lazy'}
          fetchPriority={character.id === 'absolution' ? 'high' : 'auto'}
          decoding="async"
          onError={() => setFailed(true)}
        />
      ) : (
        <div className="art-fallback" role="img" aria-label={`${current.alt}. Artwork temporarily unavailable.`}>
          <span>IMAGE SIGNAL LOST</span><b>{character.name}</b>
        </div>
      )}
      <figcaption>
        <span>{current.kind} // {String(imageIndex + 1).padStart(2, '0')}</span>
        <CharacterSpeakButton characterId={character.id} characterName={character.name} />
      </figcaption>
      <ProgressIndicator activeIndex={imageIndex} progress={frameProgress} labels={character.images.map(image => image.kind)} />
    </figure>
  );
}
